import './examTables.css';

export const MATH_NOBREAK_CLASS = 'exam-math-nobreak';

// What may not start a line after a formula: a full stop, comma, semicolon,
// colon, question or exclamation mark, ellipsis, or a closing bracket. Only
// the run straight after the formula, with no space between, goes with it.
const TRAILING_PUNCTUATION = /^[.,;:?!…)\]}]+/;

/** Keep the punctuation that follows an inline formula on the formula's line.
 *
 * A typeset formula is an element (mjx-container) and the full stop after it
 * is text, so the browser may break the line between them. On a computer
 * TMUA-3007-p1 question 17's stem, "Find the value of $m_1 m_2$.", ended with
 * a lone "." on a line of its own below the stem (18 October 2026). Each
 * inline formula followed straight away by punctuation is put, with that
 * punctuation, in a span that does not wrap (examTables.css). Display maths
 * stands on its own line already and is left alone, as is a formula already
 * kept with its punctuation, so calling this again changes nothing. The text
 * node after the formula is shortened rather than replaced, as React may own
 * it. Call it after MathJax has typeset `root`.
 *
 * Returns how many formulas were joined to their punctuation. */
export function keepPunctuationWithMath(root) {
  if (!root || typeof root.querySelectorAll !== 'function' || typeof document === 'undefined') return 0;
  let joined = 0;
  root.querySelectorAll('mjx-container').forEach((container) => {
    if (container.getAttribute('display') === 'true') return;
    const parent = container.parentNode;
    if (!parent || (parent.classList && parent.classList.contains(MATH_NOBREAK_CLASS))) return;
    const next = container.nextSibling;
    if (!next || next.nodeType !== Node.TEXT_NODE) return;
    const match = next.data.match(TRAILING_PUNCTUATION);
    if (!match) return;
    const span = document.createElement('span');
    span.className = MATH_NOBREAK_CLASS;
    parent.insertBefore(span, container);
    span.appendChild(container);
    span.appendChild(document.createTextNode(match[0]));
    next.data = next.data.slice(match[0].length);
    joined += 1;
  });
  return joined;
}
